// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type RequestExternalAccountCreateMutationVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
  types: Array<Types.EmployeeExternalAccountType> | Types.EmployeeExternalAccountType;
}>;

export type RequestExternalAccountCreateMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'requestExternalAccountCreate'
>;

export const RequestExternalAccountCreateDocument = /*#__PURE__*/ gql`
    mutation requestExternalAccountCreate($employeeId: ID!, $types: [EmployeeExternalAccountType!]!) {
  requestExternalAccountCreate(employeeId: $employeeId, types: $types)
}
    `;
export type RequestExternalAccountCreateMutationFn = Apollo.MutationFunction<
  RequestExternalAccountCreateMutation,
  RequestExternalAccountCreateMutationVariables
>;

/**
 * __useRequestExternalAccountCreateMutation__
 *
 * To run a mutation, you first call `useRequestExternalAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestExternalAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestExternalAccountCreateMutation, { data, loading, error }] = useRequestExternalAccountCreateMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useRequestExternalAccountCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestExternalAccountCreateMutation,
    RequestExternalAccountCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestExternalAccountCreateMutation, RequestExternalAccountCreateMutationVariables>(
    RequestExternalAccountCreateDocument,
    options,
  );
}
export type RequestExternalAccountCreateMutationHookResult = ReturnType<typeof useRequestExternalAccountCreateMutation>;
export type RequestExternalAccountCreateMutationOptions = Apollo.BaseMutationOptions<
  RequestExternalAccountCreateMutation,
  RequestExternalAccountCreateMutationVariables
>;
